import io from 'socket.io-client';

// eslint-disable-next-line
const loggers = [(meta, data) => console.log(data)];

const meta = {
  platform: {
    osType: 'WebApp',
    channel: 'web',
    tag: process.env.TAG_COMMIT,
    osVersion: process.env.TAG_COMMIT,
    hash: process.env.HASH_COMMIT,
    userAgent: navigator.userAgent,
  },
  user: {},
};

const room = {
  id: undefined,
};

export const updateUserInfo = user => {
  meta.user = { ...meta.user, ...user };
};

export const updateRoomId = id => {
  room.id = id;
};

export const init = () =>
  new Promise(resolve => {
    const socket = io('https://chabarak-production.ava.me/', {
      transports: ['websocket'],
    });
    socket.on('connect', () => {
      loggers.push((m, data) =>
        socket.emit('log', JSON.stringify({ meta: m, data }))
      );
      resolve('Chabarak logger initialized');
    });
  });

export const log = (tag, level, content) => {
  loggers.map(f =>
    f(meta, { tag, level, timestamp: Date.now(), content, roomId: room.id })
  );
};

window.addEventListener('unhandledrejection', event => {
  log('unhandledRejection', 'error', { ...event });
});

window.onerror = (msg, url, line) => {
  log('windowOnError', 'error', { msg, url, line });
};
